<template>
  <a :title="product.name" :href="product.url" :data-id="product.id"
    class="products__item trackProductClick kuTrackRecentView"
    @click="trackProductClick"
  >
    <ImageField 
      :key="searchTerm.length > 0 ? product.image : product.imageUrl"
      class="product__img"
      :obj="{'url':searchTerm.length > 0 ? product.image : product.imageUrl,'alt':'Product Image','width':254,'height':314}" 
    />
    <span class="product__title">{{ product.name }}</span>
    <div v-if="searchTerm.length > 0" class="product__price-wrapper">
      <span :class="['product__price', {'bold': product.price!= discountPrice}]">{{ formatPrice(discountPrice) }}</span>
      <span v-if="product.startPrice && product.startPrice != product.salePrice && customerDiscountVal <= 0" class="product__price-range">
        ( {{formatPrice(product.startPrice) }} -  {{formatPrice(product.salePrice) }} )
      </span>
      <span v-else-if="product.price!= discountPrice" class="product__compare-price">{{ formatPrice(product.price) }}</span>
    </div>
  </a>
</template>

<script setup>
  import { computed, toRefs, ref } from 'vue';
  import ImageField from '../global/image.vue';

  const props = defineProps({
    product: {
      type: Object,
      required: true,
    },

    searchTerm: {
      type: String,
      default: ''
    }
  })

  const { product, searchTerm } = toRefs(props)

  const discountPrice = computed(() => {
    const {price,salePrice} = product.value;

    if (price > 0) {
      return Math.min((price) * (1 - customerDiscountVal.value), salePrice);
    } else {
      return (salePrice) * (1 - customerDiscountVal.value);
    }
  })

  const customerDiscountVal = computed(() => {
    return product.value ? window.customerDiscount(product.value.tags) : 0
  })

  const formatPrice = (price) => {
    return window.formattedPrice(price)
  }
 
  const trackProductClick = () => {
    const {id,itemGroupId,name,url} = product.value
    const formattedUrl = `https://stats.ksearchnet.com/analytics/productTracking?klevu_apiKey=klevu-169515972703616748&klevu_keywords=${searchTerm.value}&klevu_type=clicked&klevu_productId=${id}&klevu_productGroupId=${itemGroupId}&klevu_productVariantId=${id}&klevu_productName=${name}&klevu_productUrl=${url}`;
    fetch(formattedUrl).then(() => {return true}) 
  }
</script>